export const ADD_BEER_BATCH_SIZE = 100;

/**
 * Transforms validated rows into addBeer payloads grouped by breweryId.
 */
export function transformRowsToAddBeerPayload(validatedRows, breweryIdByGroupKey, selectedRowIndices) {
  const selectedSet = new Set(selectedRowIndices);
  const byBrewery = new Map();

  validatedRows.forEach((row) => {
    if (!selectedSet.has(row.rowIndex) || !row.isValid) {
      return;
    }

    const groupKey = `${row.stateCode ?? ''}::${row.breweryName?.trim().toLowerCase() ?? ''}`;
    const breweryId = breweryIdByGroupKey[groupKey];
    if (!breweryId) {
      return;
    }

    const beerPayload = {
      name: row.beerName,
      style: row.styleId,
      abv: row.abv,
      breweryId,
    };

    if (row.styleName && row.styleType) {
      beerPayload.styleName = row.styleName;
      beerPayload.styleType = row.styleType;
    }

    if (!byBrewery.has(breweryId)) {
      byBrewery.set(breweryId, []);
    }
    byBrewery.get(breweryId).push(beerPayload);
  });

  return byBrewery;
}

/**
 * Chunks beers per brewery into batches of maxBatchSize for sequential addBeer calls.
 */
export function buildImportBatches(validatedRows, breweryIdByGroupKey, selectedRowIndices, maxBatchSize = ADD_BEER_BATCH_SIZE) {
  const byBrewery = transformRowsToAddBeerPayload(
    validatedRows,
    breweryIdByGroupKey,
    selectedRowIndices,
  );

  const batchSize = Number.isFinite(maxBatchSize) && maxBatchSize > 0 ? maxBatchSize : ADD_BEER_BATCH_SIZE;
  const batches = [];
  byBrewery.forEach((beers, breweryId) => {
    for (let start = 0; start < beers.length; start += batchSize) {
      batches.push({
        breweryId,
        beers: beers.slice(start, start + batchSize),
      });
    }
  });

  return batches;
}
